import { communityLoginURL, saasStartPath } from '@/platform/saas/tenantSite';
import { SAAS_COMMUNITIES_PATH } from '@/platform/saas/saasHostUi';

export { SAAS_COMMUNITIES_PATH };

export const SAAS_START_PATH = saasStartPath('');

export const FIND_COMMUNITY_PATH = '/find/';

export const NO_COMMUNITY_MESSAGE =
  "You're not a member of a community yet. Create a community or find one to join.";

export type SaasCommunityRow = {
  slug?: string;
  role?: string;
  loginUrl?: string;
  provisionState?: string;
};

export function communityPickHref(row: SaasCommunityRow): string {
  const fromApi = (row.loginUrl || '').trim();
  if (fromApi) return fromApi;
  return communityLoginURL(row.slug || '');
}

export function hasCommunities(rows: SaasCommunityRow[] | undefined): boolean {
  return (rows || []).some((row) => (row.slug || '').trim() !== '');
}

/** True when post-login should pick picker vs find (not an explicit create/setup return). */
export function shouldResolveHostMembershipDest(returnTo: string): boolean {
  const path = (returnTo || '/').split('?')[0].replace(/\/+$/, '') || '/';
  return path === '/' || path === '/saas/communities';
}

/** Members open the picker; everyone else goes to Find my community. */
export function destinationAfterHostLogin(rows: SaasCommunityRow[] | undefined): string {
  return hasCommunities(rows) ? SAAS_COMMUNITIES_PATH : FIND_COMMUNITY_PATH;
}

export async function resolveHostPostLoginPath(
  returnTo: string,
  fetchCommunities: () => Promise<SaasCommunityRow[] | undefined>,
): Promise<string> {
  if (!shouldResolveHostMembershipDest(returnTo)) {
    return returnTo.startsWith('/') ? returnTo : '/';
  }
  try {
    return destinationAfterHostLogin(await fetchCommunities());
  } catch {
    return SAAS_COMMUNITIES_PATH;
  }
}
